import { Injectable, inject } from '@angular/core';
import { UpgradeModule } from '@angular/upgrade/static';

@Injectable({
  providedIn: 'root'
})
export class ServiceUpgradeInjectorService {
	private upgrade = inject<UpgradeModule>(UpgradeModule);


	getAngularJsRootScope() {
		return this.upgrade.$injector.get('$rootScope');
	}

	getAngularJsUiState() {
		return this.upgrade.$injector.get('$state');
	}

	getAngularJsUiStateParams() {
		return this.upgrade.$injector.get('$stateParams');
	}
	
	getAngularJsInjector() {
		return this.upgrade.$injector;
	}
}
